import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import InstallerStatsComponent from './../Components/InstallerStatsComponent.jsx';
import { installerFiles as installerFileActions } from './../actions';
import {
  getBuildPageBuilds,
  getBuildPageBaselineBuilds,
  getBuildPageInstallerFileMetrics
} from './../reducers';
import { installer } from './../helpers';

export class InstallerStatsContainer extends Component {
  static propTypes = {
    fetchInstallerDifferences: PropTypes.func.isRequired,
    builds: PropTypes.array.isRequired,
    baselineBuilds: PropTypes.array.isRequired
  };

  componentDidUpdate() {
    if (!this.props.builds || !this.props.baselineBuilds) {
      return;
    }

    for (let i = 0; i < this.props.builds.length; ++i) {
      const build = this.props.builds[i];
      const baselineBuild = this.props.baselineBuilds[i];

      if (!build || !baselineBuild) {
        continue;
      }

      this.props.fetchInstallerDifferences(
        build.id,
        baselineBuild.id,
        build.product
      );
    }
  }

  render() {
    return (
      <InstallerStatsComponent
        {...this.props}
      />
    );
  }
}

export const mapStateToProps = (state) => {
  const metrics = getBuildPageInstallerFileMetrics(state);
  return {
    builds: getBuildPageBuilds(state),
    baselineBuilds: getBuildPageBaselineBuilds(state),
    badge: installer.getInstallerBadge(metrics),
    metrics
  };
};

export default connect(
  mapStateToProps,
  { fetchInstallerDifferences: installerFileActions.fetchInstallerDifferences }
)(InstallerStatsContainer);


// WEBPACK FOOTER //
// src/Containers/InstallerStatsContainer.jsx